import { Divider } from 'antd';
import EmbedWrapper from 'components/Embeds/EmbedWrapper';
import useLang from 'hooks/useLang';
import { useSearchParams } from 'react-router-dom';

const EmbedNewPlayerREDIRECT_TO_PAYMENT = () => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get('lang') ?? 'cs';
  const LANG = useLang(lang);
  
  return (
    <EmbedWrapper>
      <div className="m-4 mb-16 font-roboto-flex">
        <div className="text-2xl font-bold text-center mt-8 mb-8">{LANG.NEW_PLAYER_TITLE}</div>

        <div className="max-w-[800px] mx-auto">
          <Divider />
        </div>

        <div className="text-2xl font-bold text-center mt-[200px]">
          Nyní se přesměrujeme na platební bránu...
        </div>

      </div>
    </EmbedWrapper>
  )
}

export default EmbedNewPlayerREDIRECT_TO_PAYMENT